// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2fiaD","log":"ModalInventoryLogs_log__RLQUR","date":"ModalInventoryLogs_date__prSdX","userName":"ModalInventoryLogs_userName__2ntVR"};